<template>
  <div class="container-fluid">
    <form class="form-sample" @submit.prevent="update">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <router-link :to="{name:'dashboards'}">Dashboards</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{name: table_module}">{{module}}</router-link>
                </li>
                <li class="breadcrumb-item active">Details</li>
              </ol>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <div class="border-bottom text-center pb-4">
                    <img src="@/assets/face12.jpg" alt="profile" class="img-lg rounded-circle mb-3" />
                    <div class="mb-3">
                      <h3>{{ data.usr_fullname }}</h3>
                    </div>
                    <p
                      class="w-75 mx-auto mb-3"
                    >Bureau Oberhaeuser is a design bureau focused on Information- and Interface Design.</p>
                    <div class="d-flex justify-content-center">
                      <button type="button" class="btn btn-success mr-1">Detail Customers</button>
                      <button type="button" class="btn btn-secondary">{{statusTransaksi}}</button>
                    </div>
                  </div>
                  <div class="py-4">
                    <div class="mb-3">
                      <h5>Detail :</h5>
                    </div>
                    <p class="clearfix">
                      <span class="float-left">Jenis Paket</span>
                      <span
                        class="float-right text-muted"
                        v-text="(this.data.srv_t_type == 1) ? 'Biasa' : 'Paket'"
                      ></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Brand Mobil</span>
                      <span class="float-right text-muted" v-text="this.data.crs_brand_name"></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Mobil</span>
                      <span class="float-right text-muted" v-text="this.data.crs_model_name"></span>
                    </p>
                  </div>
                  <div class="py-4 border-top">
                    <div class="mb-3">
                      <h5>Info Transaksi :</h5>
                    </div>
                    <p class="clearfix">
                      <span class="float-left">Nama</span>
                      <span class="float-right text-muted" v-text="data.srv_t_fullname"></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Phone</span>
                      <span class="float-right text-muted" v-text="data.srv_t_phone"></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Alamat</span>
                      <span class="float-right text-muted" v-text="this.data.srv_t_address"></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Estimasi Waktu</span>
                      <span class="float-right text-muted" v-text="data.srv_t_estimated_time"></span>
                    </p>
                    <p class="clearfix">
                      <span class="float-left">Waktu Selesai</span>
                      <span class="float-right text-muted" v-text="data.srv_t_actual_time"></span>
                    </p>
                  </div>
                  <button class="btn btn-primary btn-block mb-2" type="submit">Proses</button>
                </div>
                <div class="col-lg-8">
                  <div class="border-bottom">
                    <ul class="nav profile-navbar">
                      <li class="nav-item">
                        <a class="nav-link active" href="javascript:;">
                          <i class="mdi mdi-newspaper"></i>
                          Transaksi
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="profile-feed">
                    <div class="d-flex align-items-start profile-feed-item row">
                      <div class="ml-4 table-responsive mr-4">
                        <table class="table" v-if="data.srv_t_type == 1">
                          <thead>
                            <tr class="bg-dark text-white">
                              <th>#</th>
                              <th>Servis</th>
                              <th class="text-right">Kode</th>
                              <th class="text-right">Harga</th>
                              <th class="text-right">Harga Pihak ke-3</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="text-right"
                              v-for="(item, index) in data.srv_t_r"
                              :key="index"
                            >
                              <td class="text-left">{{ index + 1 }}</td>
                              <td class="text-left">{{ item.srv_name }}</td>
                              <td>{{ item.srv_code }}</td>
                              <td>Rp {{ numberWithCommas(item.srv_price) }}</td>
                              <td>Rp {{ numberWithCommas(item.srv_price_external) }}</td>
                            </tr>
                          </tbody>
                        </table>

                        <table class="table" v-if="data.srv_t_type == 2">
                          <thead>
                            <tr class="bg-dark text-white">
                              <th>#</th>
                              <th>Servis</th>
                              <th class="text-right">Kode</th>
                              <th class="text-right">Harga</th>
                              <th class="text-right">Harga Pihak ke-3</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="text-right"
                              v-for="(item, index) in data.srv_t_r"
                              :key="index"
                            >
                              <td class="text-left">{{ index + 1 }}</td>
                              <td class="text-left">{{ item.srv_b_name }}</td>
                              <td>Rp {{ numberWithCommas(item.srv_b_price) }}</td>
                              <td>Rp {{ numberWithCommas(item.srv_price_external) }}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="py-4">
                          <p class="clearfix">
                            <span class="float-left">Estimasi Harga</span>
                            <span
                              class="float-right text-muted"
                              v-text="'Rp '+numberWithCommas(data.srv_t_estimated_price)"
                            ></span>
                          </p>
                          <p class="clearfix">
                            <span class="float-left">Harga Pasti</span>
                            <span class="float-right text-muted">
                              <currency-input
                                class="form-control form-control-sm"
                                v-model="post.srv_t_actual_price"
                              />
                            </span>
                          </p>
                          <p class="clearfix">
                            <span class="float-left">DP</span>
                            <span class="float-right text-muted">
                              <currency-input
                                class="form-control form-control-sm"
                                v-model="post.srv_t_dp"
                                @input="changeActual"
                              />
                            </span>
                          </p>
                          <p class="clearfix">
                            <span class="float-left">Catatan</span>
                            <span class="float-right text-muted">
                              <textarea
                                class="form-control form-control-sm"
                                rows="4"
                                v-model="post.srv_t_note"
                                :required="true"
                              ></textarea>
                            </span>
                          </p>
                          <p class="clearfix">
                            <span class="float-left">Status</span>
                            <span class="float-right">
                              <select
                                class="form-control form-control-sm"
                                v-model="post.srv_t_status"
                              >
                                <option value>-- Pilih --</option>
                                <option
                                  :value="item['dd_o_value']"
                                  v-for="(item, index) in options_status"
                                  :key="index"
                                >{{ item['dd_o_label'] }}</option>
                              </select>
                            </span>
                          </p>
                          <p class="clearfix">
                            <span class="float-left">Kategori</span>
                            <span class="float-right">
                              <select class="form-control form-control-sm" v-model="post.srv_t_cat">
                                <option value>-- Pilih --</option>
                                <option
                                  :value="item['dd_o_value']"
                                  v-for="(item, index) in options_cat"
                                  :key="index"
                                >{{ item['dd_o_label'] }}</option>
                              </select>
                            </span>
                          </p>
                        </div>
                        <div class="py-4 border-top" v-if="data.srv_t_r != undefined">
                          <div class="mb-3" v-if="data.srv_t_type == 2">
                            <h5>List Servis :</h5>
                          </div>
                          <p
                            class="clearfix"
                            v-for="(item, index) in data.srv_t_r[0].srv_t_r_srv_b_list"
                            :key="index"
                          >
                            <span class="float-left">{{ index + 1 }}. {{ item.srv_name }}</span>
                            <span class="float-right">{{ item.srv_description }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      alias_table_rel: "srv_t_r",
      data: {},
      error: {},
      post: {},
      uuid: this.$route.params.uuid,
      options_status: [],
      options_cat: [],
    };
  },
  mounted() {
    this.axios
      .get(this.table_module + "/detail/" + this.uuid)
      .then((response) => {
        this.data = response.data.data;
        var price =
          this.data.srv_t_estimated_price == null
            ? 0
            : this.data.srv_t_estimated_price;
        var dp = this.data.srv_t_dp == null ? 0 : this.data.srv_t_dp;
        this.$set(this.post, "srv_t_actual_price", price);
        this.$set(this.post, "srv_t_note", this.data.srv_t_note);
        this.$set(this.post, "srv_t_status", this.data.srv_t_status);
        this.$set(this.post, "srv_t_cat", this.data.srv_t_cat);
        this.$set(this.post, "srv_t_dp", dp);
      })
      .catch((error) => {
        if (error.response) {
          this.$router.push({ name: this.table_module });
        } else if (error.request) {
          console.log("Error", error.message);
        } else {
          console.log("Error", error.message);
        }
      });

    this.axios
      .get("/dropdown/list/srv_t_status_id")
      .then((response) => {
        this.options_status = response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });

    this.axios
      .get("/dropdown/list/srv_t_cat_id")
      .then((response) => {
        this.options_cat = response.data.data;
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });
  },
  computed: {
    getType() {
      var type = "";
      if (this.data.srv_t_type == 1) {
        type = "srv";
      } else {
        type = "srv_b";
      }

      return type;
    },
    getTypeRel() {
      var type = "";
      if (this.data.srv_t_type == 1) {
        type = "srv_t_r_srv";
      } else {
        type = "srv_t_r_srv_b";
      }

      return type;
    },
    statusTransaksi() {
      var res = "-";

      if (this.data.srv_t_status == 0) {
        res = "Not Confirm";
      } else if (this.data.srv_t_status == 1) {
        res = "Confirm";
      } else if (this.data.srv_t_status == 2) {
        res = "Progress";
      } else if (this.data.srv_t_status == 3) {
        res = "Finish";
      } else if (this.data.srv_t_status == 9) {
        res = "Cancel";
      }

      return res;
    },
  },
  methods: {
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    update() {
      this.axios
        .post(
          "/" + this.table_module + "/update/" + this.data.srv_t_uuid,
          this.post
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.$toast("Update data berhasil");
            this.$router.push({ name: this.table_module });
          }
        });
    },
    changeActual() {
      var estimasi =
        this.data.srv_t_estimated_price == null
          ? 0
          : this.data.srv_t_estimated_price;
      var dp = this.post.srv_t_dp;

      var total = estimasi - dp;
      this.$set(this.post, "srv_t_actual_price", total);
    },
  },
};
</script>